module.exports = __webpack_public_path__ + "static/media/card-invalid.fc67498c.svg";